var React = require('react');

function IconMapSettingsTrafficActive (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#30B4C0","d":"M28.333 17.111h-2.889v-3.85l2.89-3.372h-2.89V7H13.89v2.889H11l2.889 3.371v3.851H11l2.889 3.371v3.851H11l2.889 3.372V33h11.555v-5.295l2.89-3.372h-2.89v-3.85l2.89-3.372h-.001zm-8.666 13a2.889 2.889 0 1 1 .002-5.78 2.889 2.889 0 0 1-.003 5.781l.001-.001zm0-7.222a2.889 2.889 0 1 1 .002-5.778 2.889 2.889 0 0 1-.003 5.778h.001zm0-7.222a2.889 2.889 0 1 1 .002-5.778 2.889 2.889 0 0 1-.003 5.778h.001z"}));
}

IconMapSettingsTrafficActive.defaultProps = {"width":"40","height":"40"};

module.exports = IconMapSettingsTrafficActive;

IconMapSettingsTrafficActive.default = IconMapSettingsTrafficActive;
